import { api } from './client';
import { endpoints } from './endpoints';

/** Classic SportsAPI `SeasonFilters` — names, matched exactly after UrlDecode. */
export interface SeasonFilters {
  Sport?: string;
  Category?: string;
  Tournament?: string;
}

/** Classic SportsAPI `SeasonView`. `Odds` is a JSON string of markets. */
export interface SeasonView {
  Id: number;
  SportId: number;
  CategoryId: number;
  TournamentId: number;
  Sport: string;
  Category: string;
  Tournament: string;
  StartDate?: string | null;
  EndDate?: string | null;
  Name: string;
  Year?: string | null;
  Odds: string;
}

/**
 * Tournament outrights.
 * TEMP: classic SportsAPI `POST api/front/seasons` until SportsAPI2 ships
 * `api/v1/front/seasons`.
 */
export function fetchSeasons(
  filters: SeasonFilters,
  signal?: AbortSignal,
): Promise<SeasonView[]> {
  return api.post<SeasonView[]>(
    endpoints.sports.seasons.host,
    endpoints.sports.seasons.path,
    {
      Sport: filters.Sport ?? '',
      Category: filters.Category ?? '',
      Tournament: filters.Tournament ?? '',
    },
    signal,
  );
}
